import { generateUID } from "./uid";
import { UIDReset, UIDConsumer, UIDFork } from "./Control";
import { useUID, useUIDSeed } from "./hooks";
import { UID } from "./UIDComponent";
var uid = generateUID();
export { generateUID, uid, UID, UIDConsumer, UIDReset, UIDFork, useUID, useUIDSeed };



//////////////////
// WEBPACK FOOTER
// ../node_modules/react-uid/dist/es2015/index.js
// module id = 30
// module chunks = 0